var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDangerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6317 8.59554L8.3625 1.09199C7.97781 0.416336 7.26705 0 6.49763 0C5.72823 0 5.01748 0.416336 4.63278 1.09199L0.288524 8.72403C-0.0961747 9.39968 -0.0961747 10.2324 0.288524 10.908C0.673223 11.5837 1.38398 12 2.15337 12H10.8419C10.8443 12 10.8466 12 10.8466 12C12.0359 12 13 11.0222 13 9.81602C13 9.364 12.8639 8.9429 12.6317 8.59554ZM7.41952 9.32591C7.41952 9.84216 7.02779 10.2371 6.5 10.2371C5.97221 10.2371 5.58048 9.84216 5.58048 9.32591V9.30452C5.58048 8.79062 5.97221 8.39332 6.5 8.39332C7.02779 8.39332 7.41952 8.78826 7.41952 9.30452V9.32591ZM7.44064 3.18319L6.98556 7.21332C6.95507 7.50357 6.76507 7.68438 6.5 7.68438C6.23493 7.68438 6.04493 7.50119 6.01443 7.21332L5.55936 3.18081C5.52887 2.86915 5.69544 2.63362 5.9816 2.63362H7.01606C7.30224 2.636 7.47113 2.87153 7.44064 3.18319Z",
    fill: "#D3212D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.dcb7ee1a.svg";
export { ForwardRef as ReactComponent };